import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_SPIKING_VARIANT = defineFcm('petition_page_spiking_variant')
	.asJson(
		z.strictObject({
			petition_ids: z.array(z.number().int().nonnegative()),
			modules: z.strictObject({
				momentum_card: z.boolean(),
				signer_ticker: z.boolean(),
			}),
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		supportedGroups: { global: true, locales: true },
		context: 'Petition details page (mobile)',
		description: `Gates the spiking petition mobile experiment (petition_page_spiking_mobile_experiment) on the petition details page.
			- petition_ids: integer IDs of the petitions that take part. This is the only eligibility source: on any other petition there is no variant and no exposure.
			- modules.momentum_card: toggles the gradient momentum card shown above the mobile "Sign petition" button.
			- modules.signer_ticker: toggles the recent-signer carousel inside the momentum card.
			Unknown fields are rejected. An invalid value makes the whole FCM invalid, which disables the variant everywhere.`,
		template: {
			petition_ids: [123456],
			modules: { momentum_card: true, signer_ticker: true },
		},
	});
